import { ColumnConfig } from "../../../components/common/GenericTable";
import { ConsultingRoomData } from "../../../types/ConsultingRoom";

export const tableColumns: ColumnConfig<ConsultingRoomData>[] = [
  { key: "id", label: "Id", searchable: true },
  { key: "name", label: "Room Name", searchable: true },
  { key: "size", label: "Room Size", searchable: false },
  { key: "description", label: "Description", searchable: true },
  { key: "assignedDoctors", label: "Assigned Doctors", searchable: false },
];
